/**
 * Application routes
 *
 * @TODO The below APP_ROUTES only contains a limited number of routes as it's a new addition to the application. This
 * should be extended to include all the routes of the application.
 *
 * @constant {Object} APP_ROUTES – The individual routes of the application.
 */
export const GAME_ROUTES = {
  SWR: '/game/swr',
  SWR_ES: '/game/swr-es',
  SWR_PT: '/game/swr-pt',
  PA: '/game/pa',
  PA_ES: '/game/pa-es',
  PA_PT: '/game/pa-pt',
  SRE: '/game/sre',
  SRE_ES: '/game/sre-es',
  SRE_PT: '/game/sre-pt',
  LETTER: '/game/letter',
  LETTER_ES: '/game/letter-es',
  LETTER_EN_CA: '/game/letter-en-ca',
  PHONICS: '/game/phonics',
  MULTICHOICE: '/game/multichoice',
  MORPHOLOGY: '/game/morphology',
  CVA: '/game/cva',
  VOCAB: '/game/vocab',
  FLUENCY_ARF: '/game/fluency-arf',
  FLUENCY_ARF_ES: '/game/fluency-arf-es',
  FLUENCY_ARF_PT: '/game/fluency-arf-pt',
  FLUENCY_CALF: '/game/fluency-calf',
  FLUENCY_CALF_ES: '/game/fluency-calf-es',
  FLUENCY_CALF_PT: '/game/fluency-calf-pt',
  ROAM_ALPACA: '/game/roam-alpaca',
  ROAM_ALPACA_ES: '/game/roam-alpaca-es',
  ROAM_ALPACA_PT: '/game/roam-alpaca-pt',
  ROAV_MP: '/game/roav-mp',
  ROAV_MP_PT: '/game/roav-mp-pt',
  ROAV_RVP: '/game/roav-rvp',
  ROAV_RVP_PT: '/game/roav-rvp-pt',
  ROAV_CR: '/game/roav-cr',
  CORE_TASKS: '/game/core-tasks/:taskId',
  CORE_TASKS_PT: '/game/core-tasks-pt/:taskId',
  RAN: '/game/ran',
  SYMBOL_SEARCH: '/game/symbol-search',
  SYMBOL_SEARCH_PT: '/game/symbol-search-pt',
  ROAR_READALOUD: '/game/roar-readaloud',
  SURVEY: '/game/roar-survey',
};

export const APP_ROUTES = {
  HOME: '/',
  // ACCOUNT_PROFILE: '/profile',
  AUTH_CLASSLINK: '/auth-classlink',
  AUTH_CLEVER: '/auth-clever',
  AUTH_EMAIL_LINK: '/auth-email-link',
  AUTH_NYCPS: '/auth-nycps',
  AUTH_NYCPS_INITIATE: '/initiate-auth-nycps',
  CREATE_ADMINISTRATION: '/administration/create',
  DUPLICATE_ADMINISTRATION: '/administration/:formType/:adminId',
  EDIT_ADMINISTRATION: '/administration/:formType/:adminId',
  LAUNCH: '/launch/:launchId',
  ORGS_CREATE: '/create-orgs',
  ORGS_LIST: '/list-orgs',
  PROGRESS_REPORT: '/administration/:administrationId/:orgType/:orgId',
  REGISTER: '/register',
  SCORE_REPORT: '/scores/:administrationId/:orgType/:orgId',
  SCORE_REPORT_STUDENT: '/scores/:administrationId/:orgType/:orgId/user/:userId',
  SIGN_IN: '/signin',
  SSO: '/sso',
  UNAUTHORIZED: '/unauthorized',
};

export const ADMINISTRATION_FORM_TYPES = {
  CREATE: 'create',
  EDIT: 'edit',
  DUPLICATE: 'duplicate',
};
